<template>
  <v-card
    flat
    width="250"
    class="container-card"
    @click="$emit('startMeeting')"
    @mouseover="upHere = true"
    @mouseleave="upHere = false"
  >
    <v-row no-gutters justify="center" align="center" class="" style="height: 100%">
      <v-col cols="12" align="center">
        <v-btn
          dark
          plain
          color="rgb(40, 144, 103)"
          :ripple="false"
          :loading="isStartMeetingLoading && !startMeetingEvent"
        >
          <span class="material-icons-round add-icon" translate="no" style="font-size: 70px">add</span>
        </v-btn>
        <div v-if="upHere && $vuetify.breakpoint.width >= 960" style="position: absolute; bottom: 10px; width: 100%">
          <span style="color: #78848a; font-size: 14px; font-weight: 500">{{ 'Create a new Tape' }}</span>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
// import { copy } from '@/common/common'
import { mapGetters } from 'vuex'
// import { getShareUrl, setUserFunnel } from '@/services/api'
import { isSafari } from '@/common/lib/strLib'
// import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'ListCardItem',
  components: {},
  props: { isStartMeetingLoading: Boolean, startMeetingEvent: String },
  data() {
    return {
      upHere: false,
    }
  },
  created() {
    if (this.isSafari) this.setSafariUrl()
  },
  methods: {},
  computed: {
    ...mapGetters(['userInfo', 'selectedWsInfo', 'currentMt', 'selectedCh', 'isWsManager', 'isWsOwner']),
    isMtOrganizer() {
      let userId = this.userInfo && this.userInfo !== null ? this.userInfo['userId'] : ''
      let mtOrganizerUid = this.cardItem ? this.cardItem.mtOrganizerUid : ''
      return userId !== '' && mtOrganizerUid !== '' && userId === mtOrganizerUid
    },
    isMtCreator() {
      let userId = this.userInfo && this.userInfo !== null ? this.userInfo['userId'] : ''
      let mtCreatedUid = this.cardItem ? this.cardItem['mtCreatedUid'] : ''
      return userId !== '' && mtCreatedUid !== '' && userId === mtCreatedUid
    },
    isSafari() {
      return isSafari()
    },
  },
  watch: {},
}
</script>

<style scoped>
.isPlaying {
  border: solid 5px #ff575f !important;
  min-width: 200px;
  /* margin: -5px; */
}
.v-card--flat {
  box-shadow: 0.5px 0.5px 0 0px #222 !important;
  transition: all 0.5s;
}
.container-card {
  box-shadow: 0.5px 0.5px 0px 0px rgba(33, 33, 33, 0.3) !important;
  border-radius: 10px;
  overflow: hidden;
  min-width: 200px;
  height: 100%;
  border: 2px dashed #1a272e !important;
  transition: all 0.5s;
  background-color: transparent;
}
.container-card:hover {
  background-color: #111a1e;
}
.container-card >>> .add-icon {
  color: rgb(40, 144, 103);
  transition: all 0.5s;
}

.container-card:hover >>> .add-icon {
  color: rgb(51, 172, 124) !important;
  transition: all 0.5s;
}

@media (hover: hover) {
  .v-card--flat:hover {
    border: 2px dashed transparent !important;
    transition: all 0.5s;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
